export default () => window.location.pathname.split('/').slice(-3).join('/');
